import { useCallback } from 'react';
import { App as AntdApp } from 'antd';

import { MAX_QUERY_LENGTH, parse } from '../utils/kql';
import { applyConditionsToQuery } from '../utils/filterValues';

// The grammar caps a query's length and its number of conditions: text it
// cannot read is never written.
function fits(text) {
	if (text.length > MAX_QUERY_LENGTH) return false;
	try { parse(text); return true; } catch { return false; }
}

export const TOO_LONG_MESSAGE = 'That is more than one filter can hold. Remove one first.';

/**
 * The list's one door for "filter by this value", from wherever a value is
 * shown (a table cell's menu, a field row's menu, a lookup's title, the row's
 * ⋯): the condition is ANDed onto `?q=` (utils/filterValues
 * `applyConditionsToQuery`, the helper the column headers write through).
 *
 * A query is at most MAX_QUERY_LENGTH characters and 50 conditions (the
 * vendored grammar parses no more). A condition that would pass either is held
 * with a message and `?q=` stays as it was; without the guard the address would
 * carry text nothing can read (KPR-1712 holds a header the same way).
 */
export default function useApplyValueFilter({ query, setQuery }) {
	const { message } = AntdApp.useApp();
	return useCallback((filter) => {
		const next = applyConditionsToQuery(query, filter);
		if (typeof next === 'string' && !fits(next)) {
			message.warning(TOO_LONG_MESSAGE);
			return;
		}
		setQuery(next);
	}, [query, setQuery, message]);
}
